import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Role } from 'src/app/models/role';
import { SettingsService, ContentPermission, ContentDynamicItemObjects, ContentItemData, ItemData } from '../settings.service';
import { Title } from '@angular/platform-browser';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';

@Component({
    selector: 'app-role-content-permissions',
    templateUrl: './role-content-permissions.component.html',
    styleUrls: ['./role-content-permissions.component.scss'],
    standalone: false
})
export class RoleContentPermissionsComponent implements OnInit {


  isNewPermission: boolean = true;
  popupVisible = false;
  selectedRoleId = 0;
  roles: Role[] = [];
  selectObject = "Object";
  accessDropdown = [{ text: 'Dynamic Table', value: 'DynamicTable' }, { text: 'Object', value: 'Object' }];
  dynamicTableData = [];
  dynamicTableId: string;
  permissions: ContentPermission[] = [];
  isGridBoxOpened: boolean;
  GroupNameData: ContentDynamicItemObjects[] = [];
  groupsName: string[] = [];
  IsAccess: boolean;
  itemObjects: ContentDynamicItemObjects[];

  constructor(private settingsService: SettingsService,
    private titleService: Title, private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.titleService.setTitle("Role Content");
    this.loadRolesData();
    this.getDynamicTables();
    this.getDdlContentData();
  }

  private getDdlContentData() {
    this.settingsService.getDynamicTables("DynamicTableGroups")
      .subscribe(items => {
        this.itemObjects = items["dynamicTableGroups"];
      });
  }

  loadRolesData() {

    this.settingsService.getRoles()
      .subscribe(roles => {
        this.roles = roles;
        this.selectedRoleId = roles && roles.length ? roles[0].roleId : 0;
        if (this.selectObject == 'Object') {
          this.loadListData('pageload');
        }

      });
  }

  private getDynamicTables() {
    this.settingsService.getDynamicTables("SelectDynamic")
      .subscribe(items => {
        this.dynamicTableData = items["dynamicTbl"];
        if (this.dynamicTableData != null && this.dynamicTableData.length > 0) {
          this.dynamicTableId = this.dynamicTableData[0]["dynamicTableId"];
        }
        if (this.selectObject == 'DynamicTable') {
          this.loadListData('pageload');
        }
      });
  }

  roleChanged() {
    this.loadListData('onRoleChanges');
  }
  onObjectChanged() {
    this.loadListData('onRoleChanges');
  }

  dynamicTableChanged() {
    this.loadListData('onRoleChanges');
  }

  loadListData(action: string) {
    if (!this.selectedRoleId || !this.selectObject) {
      this.permissions = [];

      return;
    }


    let groupData = "";
    if (this.selectObject == "DynamicTable") {
      if (!this.dynamicTableId) {
        this.permissions = [];

        return;
      }
      groupData = this.dynamicTableId;
    }
    this.settingsService.getObjectContentPermissionsByRole(this.selectedRoleId, this.selectObject, groupData)
      .subscribe(permissions => {
        this.permissions = permissions;

      });
  }

  removePermission(event: any) {
    let permission = event.key as ContentPermission;
    let existingPermission = this.permissions.filter(perm => perm.groupName === permission.groupName);

    if (!existingPermission || existingPermission.length < 1) {
      return;
    }

    let existingPermissionIndex = this.permissions.indexOf(existingPermission[0]);
    this.permissions.splice(existingPermissionIndex, 1);
  }

  addNewPermission() {

    let existingGroups = this.permissions.map(permission => permission.groupName);
    this.groupsName = [];
    this.IsAccess = true;
    this.isNewPermission = true;
    this.GroupNameData = [];
    this.editvalues = [];
    this.groupSelectValues = [];
    if (this.selectObject == "DynamicTable") {
      this.GroupNameData = this.itemObjects.filter(x => x.groupType == this.selectObject && x.groupName == this.dynamicTableId
        && !existingGroups.includes(x.groupObjectName)
      )
    }
    else {
      this.GroupNameData = this.itemObjects.filter(x => x.groupType == this.selectObject
        && !existingGroups.includes(x.groupObjectName)).sort((a, b) => (a.groupObjectName < b.groupObjectName) ? -1 : 1);
    }

    if (this.GroupNameData != null && this.GroupNameData.length > 0) {
      this.GroupNameData.sort((a, b) => (a.groupObjectName < b.groupObjectName) ? -1 : 1);
    }
    this.popupVisible = true;
    this.getCaption();
  }

  groupValues: ItemData[];
  contentItems: ContentItemData[] = [];
  onGroupNameChanged() {
    if (this.groupsName != null && this.groupsName.length > 0) {
      this.loadValuesDataByGroupName(this.groupsName[0], 'onchage');
      this.isGridBoxOpened = false;
    }
    this.getCaption();
  }

  loadValuesDataByGroupName(groupName: string, action: string) {
    try {
      if (this.groupsName != null && this.groupsName.length > 0) {

        if (this.contentItems.length == 0 || this.contentItems.filter(x => x.name == groupName).length == 0) {
          this.settingsService.GetContentItemsByObject(this.selectObject, groupName, this.dynamicTableId)
            .subscribe(items => {
              if (items.values != null && items.values.length > 0) {
                let varDynamicTableId = "0";
                if (this.selectObject == 'DynamicTable') {
                  varDynamicTableId = this.dynamicTableId;
                }
                this.contentItems.push({ name: groupName, values: items.values, id: varDynamicTableId });
              }

              this.loadValues(groupName, action);
            });
        }
        else {

          this.loadValues(groupName, action);
        }
      }
    } catch (error) {

    }
  }
  groupSelectValues: string[];
  loadValues(groupName: string, action: string) {
    let varDynamicTableId = "0";
    if (this.selectObject == 'DynamicTable') {
      varDynamicTableId = this.dynamicTableId;
    }
    let content = this.contentItems
      .filter(content => content.name === groupName && content.id === varDynamicTableId);
    let values = content && content.length
      ? content[0].values : [];
    this.groupValues = (values != null ? values : []);
    if (action == 'edit') {
      this.groupSelectValues = this.editvalues;
    }
  }

  caption = "";
  getCaption() {
    this.caption = "";
    if (this.groupsName != null && this.groupsName.length > 0) {
      if (this.selectObject == 'DynamicTable') {
        let captionName = this.itemObjects.find(x => x.groupObjectName == this.groupsName[0]
          && x.groupName == this.dynamicTableId && x.groupType == this.selectObject);
        if (this.caption != null && captionName != null && captionName.captions != null) {
          this.caption = captionName.captions;
        }
      }
      else {
        let captionName = this.itemObjects.find(x => x.groupObjectName == this.groupsName[0] && x.groupType == this.selectObject);
        if (this.caption != null && captionName != null && captionName.captions != null) {
          this.caption = captionName.captions;
        }
      }

    }
    return this.caption;
  }

  addUpdatePermission() {
    if (this.groupsName != null && this.groupsName.length > 0 && this.groupValues != null
      && this.groupSelectValues.length > 0) {
      if (this.isNewPermission) {
        let captions = this.getCaption();
        let prmsItem: ContentPermission = { access: this.IsAccess, groupName: this.groupsName[0], groupValues: this.groupSelectValues, groupCaptions: captions };
        this.permissions.push(prmsItem);
      } else {
        let prmsItem = this.permissions.filter(item => item.groupName === this.groupsName[0])[0];
        prmsItem.groupName = this.groupsName[0];
        prmsItem.groupValues = this.groupSelectValues;
        prmsItem.access = this.IsAccess;
      }
      this.popupVisible = false;
    }
    else {
      AppDevNotifyComponent.ErrorMessage("Please select at least one object.");
    }
  }

  editvalues: string[];
  editPermission(event: any) {
    event.cancel = true;
    if (event != null && event.data) {

      let item = event.data as ContentPermission;
      this.IsAccess = item.access;
      this.groupsName = [item.groupName];
      this.isNewPermission = false;
      this.popupVisible = true;

      this.editvalues = item.groupValues;
      this.loadValuesDataByGroupName(item.groupName, 'edit');
      this.getCaption();
    }
  }

  save() {

    this.settingsService.saveContentPermissionsByRole(this.permissions, this.selectedRoleId
      , this.dynamicTableId, this.selectObject)
      .subscribe(
        (result) => {
          if (result && result.length > 0) {
            if (result[0]["flag"] == "1") {
              AppDevNotifyComponent.SuccesMessage(result[0]["msg"]);
            } else {
              AppDevNotifyComponent.ErrorMessage(result[0]["msg"]);
            }
          }

        },
        (error) => console.error(error))
      .add(() => {});
  }

  calculateCaptions(data) {
    if (data.captions == data.groupObjectName) {
      return data.groupObjectName;
    }
    return data.captions + ' (' + data.groupObjectName + ')';
  }

  calculateCaptionsGridList(data) {
    if (data.groupCaptions == data.groupName) {
      return data.groupName;
    }
    if (data.groupCaptions == null || data.groupCaptions == undefined) {
      return data.groupName;
    }
    return data.groupCaptions + ' (' + data.groupName + ')';
  }
}
